module.exports = __webpack_public_path__ + "media/customizations/pomonalife/logo-new-78d08367cb390ff175fa80fa135c8e5f.png";